export default __webpack_public_path__ + "images/bb64adf5e9eb4f45c5a825803d6565f1-check-midnight-purple.svg";